import { Helmet } from "react-helmet-async";
import CardLayout from "../../layouts/CardLayout";
import React, { useEffect, useState } from "react";
import errorHandler from "../../utils/errorHandler";
import { useNavigate, useParams } from "react-router-dom";
import { Grid, Card, CardHeader, CardContent, Box, FormHelperText, InputLabel, Divider, Button, Stack } from "@mui/material";
import CoursesManagementList from "../../services/coursesManagementSerives";

const TaskListCource = () => {
    const { id } = useParams();
    const [data, setData] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            try {
                // const response = await TeacherManagementService.ViewScoreStudent({ id });
                const response = await CoursesManagementList.getById({ id: id });
                setData(response?.data?.data?.tasks);
            } catch (error) {
                errorHandler(error);
            }
        };

        fetchData();
    }, [id]);

    const handleViewTask = (taskId) => {
        navigate(`/course-management/taskpreview/${id}/task/${taskId}/explanation`, { state: { panelType: 'teacher' } });
    };

    return (
        <Box>
            <Helmet>
                <title>Student Grade</title>
            </Helmet>
            <CardLayout>
                <CardHeader title={`Student Grades`} />
                <CardContent>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={12}>
                            <Card sx={{ boxShadow: 4, borderRadius: 3, overflow: "hidden" }}>
                                <CardContent>
                                    <Grid container spacing={3}>
                                        {data.length > 0 ? (
                                            data.map((course, taskIndex) => (
                                                <React.Fragment key={taskIndex}>

                                                    <Grid item xs={12} md={6} key={taskIndex}>
                                                        <div className="view-score-list" >
                                                           <p> {course.taskId?.title}</p>


                                                            <Button
                                                                variant="contained"
                                                                onClick={() => handleViewTask(course.taskId._id)}
                                                            >
                                                                PreView Task
                                                            </Button>
                                                            {/* <p style={{width:'100%'}}>
                                                                {course?.startDate}{course?.dueDate}{course?.endDate}
                                                                </p> */}
                                                        </div>
                                                    </Grid>



                                                </React.Fragment>
                                            ))
                                        ) : (
                                            <Grid item xs={12}>
                                                <InputLabel>No tasks available</InputLabel>
                                            </Grid>
                                        )}
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </CardContent>
            </CardLayout>
        </Box>
    );
};

export default TaskListCource;
